module.exports = __webpack_public_path__ + "img/q2.ceffe17d.png";